import React from 'react';
import { useAppStore } from '../store/useAppStore';
import Icon from './Icon';

const ICONS: Record<string, string> = {
  success: 'check', warn: 'warn', danger: 'x', info: 'info',
};

export default function ToastHost() {
  const { toasts, dismissToast } = useAppStore();

  if (!toasts.length) return null;

  return (
    <div className="t-toast-host">
      {toasts.map((t) => (
        <div key={t.id} className={`t-toast ${t.variant}`}>
          <Icon name={ICONS[t.variant]} size={14} color={`var(--${t.variant})`} />
          <span style={{ flex: 1 }}>{t.message}</span>
          <button onClick={() => dismissToast(t.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ink-3)', padding: 2 }}>
            <Icon name="x" size={12} color="var(--ink-3)" />
          </button>
        </div>
      ))}
    </div>
  );
}
